import { render, staticRenderFns } from "./dictData.vue?vue&type=template&id=654322b8&scoped=true&"
import script from "./dictData.vue?vue&type=script&lang=js&"
export * from "./dictData.vue?vue&type=script&lang=js&"
import style0 from "./dictData.vue?vue&type=style&index=0&id=654322b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654322b8",
  null
  
)

export default component.exports